<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section
    [class]="'fudis-mt-md'"
    [width]="'lg'"
    [level]="2"
    [titleVariant]="'lg'"
    [title]="stepNumber + '. ' + t('GRADUATION_WIZARD.STEP_3')">
    <fudis-section-content>
      @if (degreeProgramme) {
        <fudis-heading [class]="'fudis-mt-md'" [level]="3" [variant]="'md'">{{
          t("GRADUATION_WIZARD.STEP_3_SUBTITLE", { name: degreeProgrammeName })
        }}</fudis-heading>
      }
      <fudis-body-text [class]="'fudis-mt-sm'">{{ t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.INFO_TEXT") }}</fudis-body-text>
      @if (localProfile) {
        <fudis-heading [class]="'fudis-mt-md'" [level]="3" [variant]="'sm'">{{ t("PROFILE.PERSONAL_INFO") }}</fudis-heading>
        <sis-person-info-for-graduation [person]="localProfile" />
        <fudis-heading [class]="'fudis-mt-md'" [level]="3" [variant]="'sm'">{{ t("PROFILE.CONTACT_INFO") }}</fudis-heading>
        <sis-contact-info-for-graduation [person]="localProfile" [level]="4" />
        <fudis-section-actions>
          <fudis-button
            [variant]="'secondary'"
            [label]="t('GRADUATION_WIZARD.EDIT_CONTACT_INFORMATION')"
            (handleClick)="openEditContactInformation()" />
        </fudis-section-actions>
      }
      <fudis-heading [class]="'fudis-mt-md'" [level]="3" [variant]="'sm'">{{
        t("GRADUATION_WIZARD.ADDITIONAL_INFO_HEADING")
      }}</fudis-heading>
      <fudis-body-text [class]="'fudis-mt-sm'">{{ t("GRADUATION_WIZARD.ADDITIONAL_INFO_HELP_TEXT") }}</fudis-body-text>
      @for (question of questions; track question) {
        <fudis-text-area
          [class]="'fudis-mt-sm'"
          [size]="'full-width'"
          [label]="question.question | localizedString"
          [helpText]="question.guidance | localizedString | plainText"
          [control]="getQuestionControl(question.localId)">
        </fudis-text-area>
      }
      <fudis-text-area
        [class]="'fudis-mt-sm'"
        [size]="'full-width'"
        [label]="t('GRADUATION_WIZARD.ADDITIONAL_INFO')"
        [control]="additionalInfoControl">
      </fudis-text-area>
      @if (!digitalDegreeCertificatePreferred) {
        <fudis-heading [class]="'fudis-mt-md'" [level]="3" [variant]="'sm'">
          {{ t("GRADUATION_WIZARD.DEGREE_DELIVERY.TITLE") }}
        </fudis-heading>
        <fudis-body-text [class]="'fudis-mt-sm'">{{ t("GRADUATION_WIZARD.DEGREE_DELIVERY.INFO") }}</fudis-body-text>

        <fieldset class="fudis-mt-sm">
          <legend class="fudis-label-md-regular">{{ t("GRADUATION_WIZARD.DEGREE_DELIVERY.LABEL_TITLE") }}</legend>
          <div class="fudis-mt-xs">
            <sis-simple-radio-button
              [name]="'degree-delivery-method'"
              [id]="'delivery-pick-up'"
              [selected]="degreeDeliveryMethod.value === 'PICK_UP'"
              label="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.PICK_UP"
              (selectedChange)="degreeDeliveryMethod.setValue('PICK_UP')" />
          </div>
          <div class="fudis-mt-xs">
            <sis-simple-radio-button
              [name]="'degree-delivery-method'"
              [id]="'delivery-mail'"
              [selected]="degreeDeliveryMethod.value === 'MAIL'"
              label="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.MAIL"
              (selectedChange)="degreeDeliveryMethod.setValue('MAIL')" />
          </div>
          @if (degreeDeliveryMethod.value === "MAIL") {
            <div class="fudis-ml-xl border-start border-2 ps-3">
              <fieldset>
                <legend class="fudis-label-md-regular fudis-mt-sm">
                  {{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.BY_MAIL_GUIDANCE") }}
                </legend>
                <div class="fudis-mt-xs">
                  <sis-simple-radio-button
                    [name]="'delivery-address-type'"
                    [id]="'delivery-primary'"
                    [selected]="deliveryAddressType.value === 'PRIMARY'"
                    label="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.CONTACT_INFO.PRIMARY_ADDRESS"
                    (selectedChange)="deliveryAddressType.setValue('PRIMARY')" />
                  @if (localProfile?.primaryAddress) {
                    <div class="fudis-pl-xl fudis-mt-xxs">
                      <ng-container *ngTemplateOutlet="addressTemplate; context: { address: localProfile.primaryAddress }" />
                    </div>
                  }
                </div>
                @if (localProfile?.secondaryAddress) {
                  <div class="fudis-mt-xs">
                    <sis-simple-radio-button
                      [name]="'delivery-address-type'"
                      [id]="'delivery-secondary'"
                      [selected]="deliveryAddressType.value === 'SECONDARY'"
                      label="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.CONTACT_INFO.SECONDARY_ADDRESS"
                      (selectedChange)="deliveryAddressType.setValue('SECONDARY')" />
                    <div class="fudis-pl-xl fudis-mt-xxs">
                      <ng-container *ngTemplateOutlet="addressTemplate; context: { address: localProfile.secondaryAddress }" />
                    </div>
                  </div>
                }
              </fieldset>
              <fudis-notification [class]="'fudis-mt-sm'" [variant]="'warning'">
                <fudis-body-text>
                  {{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY_MAIL_NOTIFICATION") }}
                </fudis-body-text>
              </fudis-notification>
            </div>
          }
        </fieldset>
      }

      <ng-template #addressTemplate let-address="address">
        @if (isFinnishAddress(address)) {
          <span>{{ address.streetAddress }}</span>
          <span>, {{ address.postalCode }} {{ address.city }}</span>
        } @else {
          <span>{{ parsedGenericAddress($any(address)) }}</span>
        }
        <span>, {{ $any(address).countryUrn | codeLocalizedName | async }}</span>
      </ng-template>
      @if (showAlumniSection) {
        <fudis-heading [class]="'fudis-mt-md'" [level]="3" [variant]="'sm'">
          {{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.ALUMNI_ASSOCIATION.TITLE") }}
        </fudis-heading>
        @if (alumniAssociationDescription) {
          <fudis-body-text [class]="'fudis-mb-sm'">{{ alumniAssociationDescription }}</fudis-body-text>
        }
        @if (alumniAssociationUrl) {
          <fudis-body-text [class]="'fudis-mb-sm'">
            <a [href]="alumniAssociationUrl" target="_blank" rel="noopener noreferrer">
              {{ alumniAssociationUrl }}
              <span class="visually-hidden">{{ t("ARIA_LABEL.OPENS_TO_A_NEW_TAB") }}</span>
            </a>
          </fudis-body-text>
        }
        <fudis-checkbox
          [class]="'fudis-mb-sm'"
          [control]="joinsAlumniAssociation"
          [label]="t('STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.ALUMNI_ASSOCIATION.CHECKBOX')">
        </fudis-checkbox>
        @if (alumniAssociationInfoText) {
          <fudis-body-text [class]="'fudis-mt-sm'">{{ alumniAssociationInfoText }}</fudis-body-text>
        }
        @if (!alumniAssociationInfoText) {
          <fudis-body-text [class]="'fudis-mt-sm'">{{ getDefaultAlumniAssociationInfoText() | async }}</fudis-body-text>
        }
      }
      <sis-wizard-step-buttons [backButtonDisplay]="false" [forwardButtonTitle]="t('GRADUATION_WIZARD.SUBMIT_BUTTON')" (forward)="submit()">
      </sis-wizard-step-buttons>
    </fudis-section-content>
  </fudis-section>
</ng-container>
